module.exports = __webpack_public_path__ + "static/media/Google_Logo.c56ed6f0.svg";